import React from 'react';
import { Box, Typography, Card, CardContent } from '@material-ui/core';
import { Schedule as ScheduleIcon, Store as StoreIcon } from '@material-ui/icons';
import { useStyles } from '../styles.jsx';
import { withCleanProps } from '../utils/cleanProps.jsx';

// Versões limpas dos componentes Material-UI
const CleanBox = withCleanProps(Box);
const CleanTypography = withCleanProps(Typography);
const CleanCard = withCleanProps(Card);
const CleanCardContent = withCleanProps(CardContent);

const ClosedScreen = ({ proximaAbertura }) => {
  // Carrega os dados do restaurante para usar as cores customizadas
  const [restaurante, setRestaurante] = React.useState({});
  const styles = useStyles(restaurante);

  React.useEffect(() => {
    const cache = localStorage.getItem('restaurante');
    if (cache) {
      setRestaurante(JSON.parse(cache));
    }
  }, []);

  // Obter hora atual formatada
  const getCurrentTime = () => {
    return new Date().toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getCurrentDate = () => {
    return new Date().toLocaleDateString('pt-BR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <CleanBox className={`${styles.root} ${styles.navy}`}>
      <CleanBox
        className={`${styles.main} ${styles.center}`}
        style={{ 
          padding: '48px 32px',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          minHeight: '100vh'
        }}
      >
        {/* Ícone principal da loja fechada */}
        <StoreIcon 
          style={{ 
            fontSize: 140, 
            color: 'white',
            marginBottom: 32,
            filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.3))',
            opacity: 0.9
          }} 
        />
        
        {/* Título principal */}
        <CleanTypography
          variant="h1"
          component="h1"
          style={{
            marginBottom: 16,
            color: 'white',
            textShadow: '0 3px 10px rgba(0,0,0,0.3)',
            fontSize: '3.5rem',
            fontWeight: 'bold',
            letterSpacing: '1px'
          }}
        >
          ESTAMOS FECHADOS
        </CleanTypography>

        {/* Subtítulo */}
        <CleanTypography
          variant="h5"
          style={{
            marginBottom: 40,
            color: 'rgba(255, 255, 255, 0.85)',
            textShadow: '0 2px 6px rgba(0,0,0,0.2)',
            fontSize: '1.6rem',
            fontWeight: 300
          }}
        >
          Nosso atendimento não está disponível no momento
        </CleanTypography>

        {/* Card com informações */}
        <CleanCard 
          className={styles.card}
          style={{
            padding: '32px',
            borderRadius: '20px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
            background: 'rgba(255, 255, 255, 0.98)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            maxWidth: '600px',
            width: '100%'
          }}
        >
          <CleanCardContent style={{ padding: '24px 32px' }}>
            {/* Horário atual */}
            <CleanBox style={{ marginBottom: 32, textAlign: 'center' }}>
              <ScheduleIcon 
                style={{ 
                  fontSize: 48, 
                  color: restaurante.corPrimaria || '#fa5b6d',
                  marginBottom: 12
                }} 
              />
              <CleanTypography 
                variant="h6" 
                style={{ 
                  color: '#333', 
                  marginBottom: 8,
                  fontSize: '1.4rem',
                  fontWeight: 'bold'
                }}
              >
                Agora são {getCurrentTime()}
              </CleanTypography>
              <CleanTypography 
                variant="body1" 
                style={{ 
                  color: '#666',
                  fontSize: '1.1rem'
                }}
              >
                {getCurrentDate()}
              </CleanTypography>
            </CleanBox>

            {/* Próxima abertura */}
            {proximaAbertura && (
              <CleanBox 
                style={{
                  background: `linear-gradient(135deg, ${restaurante.corPrimaria || '#fa5b6d'}10, ${restaurante.corSecundaria || '#ff1744'}10)`,
                  border: `2px solid ${restaurante.corPrimaria || '#fa5b6d'}40`,
                  borderRadius: '16px',
                  padding: '24px',
                  marginTop: 24,
                  textAlign: 'center'
                }}
              >
                <CleanTypography 
                  variant="body1" 
                  style={{ 
                    color: '#666',
                    marginBottom: 8,
                    fontSize: '1.1rem',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    fontWeight: 500
                  }}
                >
                  Próxima Abertura
                </CleanTypography>
                <CleanTypography 
                  variant="h4" 
                  style={{ 
                    color: restaurante.corPrimaria || '#fa5b6d',
                    fontWeight: 'bold',
                    fontSize: '2rem'
                  }}
                >
                  {proximaAbertura}
                </CleanTypography>
              </CleanBox>
            )}

            {/* Mensagem de despedida */}
            <CleanBox style={{ marginTop: 32, textAlign: 'center' }}>
              <CleanTypography 
                variant="h6"
                style={{ 
                  color: restaurante.corPrimaria || '#fa5b6d',
                  fontSize: '1.3rem',
                  fontWeight: 500,
                  lineHeight: 1.4
                }}
              >
                Obrigado pela preferência! 
              </CleanTypography>
              <CleanTypography 
                variant="body1"
                style={{ 
                  color: '#666',
                  fontSize: '1.1rem',
                  marginTop: 8
                }}
              >
                Retornaremos em breve para atendê-lo melhor
              </CleanTypography>
            </CleanBox>
          </CleanCardContent>
        </CleanCard>
      </CleanBox>
    </CleanBox>
  );
};

export default ClosedScreen;
